/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { ArrayConfiguration } from '../models/array-configuration';
import { DateRestriction } from '../models/date-restriction';
import { DurationConfiguration } from '../models/duration-configuration';
import { FormElementStyle } from '../models/form-element-style';
import { FormElementType } from '../models/form-element-type';
import { FormSectionLayoutDefinition } from '../models/form-section-layout-definition';
import { LookupConfiguration } from '../models/lookup-configuration';
export interface FormElementLayoutDefinition {
  arrayConfiguration?: ArrayConfiguration;
  dateRestriction?: DateRestriction;
  durationConfiguration?: DurationConfiguration;
  elementStyle?: FormElementStyle;
  elementType: FormElementType;
  forcesFullWidth?: boolean | null;
  forcesNewRow?: boolean | null;
  guidanceText?: string | null;
  isDisabled?: boolean | null;
  isHidden?: boolean | null;
  isLockable?: boolean | null;
  isRequired?: boolean | null;
  label?: string | null;
  lines?: number | null;
  lookupConfiguration?: LookupConfiguration;
  mask?: string | null;
  maskDescription?: string | null;
  max?: number | null;
  min?: number | null;
  name: string;
  placeholder?: string | null;
  prefix?: string | null;
  sectionLayoutDefinitions?: Array<FormSectionLayoutDefinition> | null;
  suffix?: string | null;
  validateWhenDisabled?: boolean;
}

export class FormElementLayoutDefinition {
  arrayConfiguration?: ArrayConfiguration;
  dateRestriction?: DateRestriction;
  durationConfiguration?: DurationConfiguration;
  elementStyle?: FormElementStyle;
  elementType: FormElementType;
  forcesFullWidth?: boolean | null;
  forcesNewRow?: boolean | null;
  guidanceText?: string | null;
  isDisabled?: boolean | null;
  isHidden?: boolean | null;
  isLockable?: boolean | null;
  isRequired?: boolean | null;
  label?: string | null;
  lines?: number | null;
  lookupConfiguration?: LookupConfiguration;
  mask?: string | null;
  maskDescription?: string | null;
  max?: number | null;
  min?: number | null;
  name: string;
  placeholder?: string | null;
  prefix?: string | null;
  sectionLayoutDefinitions?: FormSectionLayoutDefinition[] | null;
  suffix?: string | null;
  validateWhenDisabled?: boolean;

  constructor(value: FormElementLayoutDefinition) {
    this.arrayConfiguration = value?.arrayConfiguration ? new ArrayConfiguration(value.arrayConfiguration) : undefined;
    this.dateRestriction = value?.dateRestriction ? new DateRestriction(value.dateRestriction) : undefined;
    this.durationConfiguration = value?.durationConfiguration ? new DurationConfiguration(value.durationConfiguration) : undefined;
    this.elementStyle = value?.elementStyle ? Object.entries(Object.values(FormElementStyle)).flatMap((x) => x).find(x => x === value.elementStyle) as FormElementStyle : undefined;
    this.elementType = Object.entries(Object.values(FormElementType)).flatMap((x) => x).find(x => x === value.elementType) as FormElementType;
    this.forcesFullWidth = value?.forcesFullWidth;
    this.forcesNewRow = value?.forcesNewRow;
    this.guidanceText = value?.guidanceText;
    this.isDisabled = value?.isDisabled;
    this.isHidden = value?.isHidden;
    this.isLockable = value?.isLockable;
    this.isRequired = value?.isRequired;
    this.label = value?.label;
    this.lines = value?.lines;
    this.lookupConfiguration = value?.lookupConfiguration ? new LookupConfiguration(value.lookupConfiguration) : undefined;
    this.mask = value?.mask;
    this.maskDescription = value?.maskDescription;
    this.max = value?.max;
    this.min = value?.min;
    this.name = value.name;
    this.placeholder = value?.placeholder;
    this.prefix = value?.prefix;
    this.sectionLayoutDefinitions = value?.sectionLayoutDefinitions?.map((x) => new FormSectionLayoutDefinition(x));
    this.suffix = value?.suffix;
    this.validateWhenDisabled = value?.validateWhenDisabled;
  }
}
